import { useEffect } from 'react'
import { branding } from '../resources'

export const useGoogleTagManager = () => {
    useEffect(() => {
        const injectGTM = async () => {
            if ((window as any).__gtmInitialized) return
                ; (window as any).__gtmInitialized = true

            try {
                const gtmContainerId = branding.gtmContainerId

                if (!gtmContainerId) return

                // Inject <script> into <head>
                const script = document.createElement('script')
                script.innerHTML = `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id=' + i + dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${gtmContainerId}');
        `
                document.head.appendChild(script)

                // Inject <noscript> safely after existing <noscript> or #root
                const noscript = document.createElement('noscript')
                noscript.innerHTML = `
          <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmContainerId}"
                  height="0" width="0" style="display:none;visibility:hidden"></iframe>
        `

                const existingNoScript = document.querySelector('noscript')
                const root = document.getElementById('root')

                if (existingNoScript && existingNoScript.nextSibling) {
                    document.body.insertBefore(noscript, existingNoScript.nextSibling)
                } else if (root) {
                    document.body.insertBefore(noscript, root)
                } else {
                    document.body.appendChild(noscript)
                }
            } catch (err) {
                console.error('GTM injection failed:', err)
            }
        }

        injectGTM()
    }, [])
}
